import { apiFetchV2 } from '@m/utils/http';

import type { EvaluationContext } from '@m/services/experimentation/EvaluationContext';

export type { EvaluationContext };

export interface ExperimentResponse {
  group: string;
  name: string;
  parameters: Record<string, unknown>;
}

export const CONTROL_RESPONSE = (name: string): ExperimentResponse => ({
  name,
  group: 'control',
  parameters: {},
});

export const ExperimentService = {
  getExperiment: (experimentName: string, evaluationContext?: EvaluationContext) =>
    apiFetchV2<ExperimentResponse>('/experiment', {
      method: 'POST',
      body: { experimentName, evaluationContext },
    }),
};
